import { IDENTIFICATION_DOCUMENT_TYPES } from "@bitComponents/utils/validators";
import { commonTypes } from "../common";

export const types = {
  INCORRECT_VALIDATION_PIN: "REGISTER/INCORRECT_VALIDATION_PIN",
  VALIDATION_PIN_EXPIRED: "REGISTER/VALIDATION_PIN_EXPIRED",
};

export const initialState = {
  register: {
    inputs: {
      name: {
        value: "",
        validationObj: null,
        customError: "",
      },
      firstSurname: {
        value: "",
        validationObj: null,
        customError: "",
      },
      secondSurname: {
        value: "",
        validationObj: null,
        customError: "",
      },
      documentType: {
        value: IDENTIFICATION_DOCUMENT_TYPES.DNI,
        validationObj: null,
        customError: "",
      },
      documentNumber: {
        value: "",
        validationObj: null,
        customError: "",
      },
      nationality: {
        value: "ES",
        validationObj: null,
        customError: "",
      },
      contactPhone: {
        value: "",
        validationObj: null,
        customError: "",
      },
      email: {
        value: "",
        validationObj: null,
        customError: "",
      },
    },
    incorrectValidationPin: false,
    validationPinExpired: false,
  },
};

const UINeedsRegisterReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_REGISTER_INPUT_VALUE: {
      const { name, value, validationObj, customError } = action.payload;
      const newState = {
        ...state,
        register: {
          ...state.register,
          inputs: {
            ...state.register.inputs,
            [name]: {
              value,
              validationObj,
              customError,
            },
          },
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case commonTypes.SET_ADDRESS_INFO: {
      const { locationId, fullAddress } = action.payload;
      const newState = {
        ...state,
        register: {
          ...state.register,
          addressInfo: {
            id: locationId,
            address: fullAddress,
          },
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case commonTypes.SET_SHIPPING_ADDRESS_NAME: {
      const { address } = action.payload;
      const newState = {
        ...state,
        register: {
          ...state.register,
          addressInfo: {
            ...state.register.addressInfo,
            address,
          },
        },
      };
      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case commonTypes.REGISTER_SHOPPER: {
      const newState = {
        ...state,
        register: {
          ...state.register,
          pinValidationInProgress: false,
          incorrectValidationPin: false,
          validationPinExpired: false,
        },
      };
      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case commonTypes.VALIDATE_SHOPPER: {
      const newState = {
        ...state,
        register: {
          ...state.register,
          pinValidationInProgress: true,
          incorrectValidationPin: false,
          validationPinExpired: false,
        },
      };
      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.INCORRECT_VALIDATION_PIN: {
      const newState = {
        ...state,
        register: {
          ...state.register,
          pinValidationInProgress: false,
          incorrectValidationPin: true,
          validationPinExpired: false,
        },
      };
      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.VALIDATION_PIN_EXPIRED: {
      const newState = {
        ...state,
        register: {
          ...state.register,
          pinValidationInProgress: false,
          incorrectValidationPin: false,
          validationPinExpired: true,
        },
      };
      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  incorrectValidationPin: (error) => ({
    type: types.INCORRECT_VALIDATION_PIN,
    payload: { error },
  }),
  validationPinExpired: (error) => ({
    type: types.VALIDATION_PIN_EXPIRED,
    payload: { error },
  }),
};

export default UINeedsRegisterReducer;
